<template>
    <div>
        <div class="user-nav" :class="{'open': open === 'user'}">
            <ul>
                <li @click="open = ''"><router-link :to="{name: '/user'}" @click="openNav('user')">Profile</router-link></li>
                <li @click="open = ''"><router-link :to="{name: '/likes'}" @click="openNav('user')">Likes</router-link></li>
                <li @click="open = ''"><router-link :to="{name: '/seens'}" @click="openNav('user')">History</router-link></li>
                <li @click="open = ''"><router-link :to="{name: 'admin_products'}" @click="openNav('user')">Admin</router-link></li>
                <li @click="open = ''"><a @click="logout()">Logout</a></li>
            </ul>
        </div>
        <nav class="navbar">
            <div class="container">
                <div class="top">
                    <router-link
                            :to="isLoggedIn == true ? '/likes' : 'login'"><img
                            src="@/assets/img/sidebar/side_heart.png" alt="Like icon"></router-link>
                    <a href=""><img src="@/assets/img/sidebar/side_search.png" alt="Search icon"></a>
                    <router-link
                            :to="isLoggedIn == true ? '/posts' : 'login'"><img src="@/assets/img/sidebar/side_post.png" alt="Post icon"></router-link>
                    <router-link
                            :to="isLoggedIn == true ? '/styles' : 'login'"><img src="@/assets/img/sidebar/side_bookmark.png" alt="Bookmark icon"></router-link>
                </div>
                <div class="middle">
                    <router-link v-if="!isLoggedIn" :to="{name: 'login'}" class="link">login</router-link>
                    <a v-else @click="openNav('user')"><img src="@/assets/img/sidebar/menu_icon.png" alt=""></a>

                    <router-link to="/how" class="link">how</router-link>
                    <router-link to="/who" class="link">who</router-link>
                </div>

                <div class="bottom">
                    <router-link to="/"><img src="@/assets/img/sidebar/sweetysmart-side-logo.png" alt="logo"></router-link>
                </div>
            </div>
        </nav>
    </div>

</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: 'Navbar',
        data() {
            return {
                open: "",
            }
        },
        computed: {
           ...mapGetters('security', [
               'isLoggedIn'
           ])
        },
        methods: {
            ...mapActions('security', [
                'logout'
            ]),
            openNav(nav) {
                if (this.open === nav) {
                    this.open = "";
                } else {
                    this.open = nav;
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .user-nav {
        position: fixed;
        top: 0;
        left: -220px;
        width: 150px;
        height: 100vh;
        background-color: var(--main-green);
        transform: skewX(-6deg);
        transition-duration: .5s;
        z-index: 998;

        &.open {
            left: -20px;
        }

        ul {
            list-style: none;
            margin: 4px 0 0;
            transform: skewX(6deg);

            a {
                font-family: Refrigerator;
                font-size: 14px;
                letter-spacing: 1px;
                display: block;
                margin-top: 8px;
                color: #7c918d;
                text-decoration: none;
            }
        }
    }

    .navbar {
        width: 30px;
        height: 100%;
        position: fixed;
        z-index: 999;
        top: 0;
        left: 0;
        transition: .5s;
        background-color: var(--main-green);

        &::before {
            position: absolute;
            content: "";
            display: block;
            width: 50px;
            left: -20px;
            height: 100vh;
            transform: skewX(-1deg);
            background-color: var(--main-green);
            z-index: -1;
        }

        .container {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            height: 100%;

            .top {
                display: flex;
                flex-direction: column;
                align-items: center;

                a {
                    display: block;
                    margin-top: 10px;

                    img {
                        height: 15px;
                    }
                }
            }

            .middle {
                display: flex;
                flex-direction: column;
                align-items: center;
                height: 150px;

                .link {
                    width: fit-content;
                    height: 40px;
                    margin-top: 10px;
                    font-size: 12px;
                    margin-left: 25px;
                    color: #7c918d;
                    text-transform: uppercase;
                    text-decoration: none;
                    transform-origin: center;
                    transform: rotate(-90deg);
                }

                a img {
                    width: 20px;
                }
            }

            .bottom img {
                width: 12px;
            }
        }
    }
</style>
